export default __webpack_public_path__ + "static/media/paypal.64ea5144.png";